import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

const BreadcrumbStructuredData = ({
  canonical, breadcrumbs = [], title
}) => {
  if (breadcrumbs && breadcrumbs.length && breadcrumbs?.[0]?.label !== 'Home') {
    breadcrumbs.unshift({ label: 'Home', url: '' });
  }
  const string = JSON.stringify({
    '@type': 'WebPage',
    name: title,
    url: canonical,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: (breadcrumbs || []).map(({ label, url }, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Thing',
          name: label,
          '@id': `https://www.homedepot.com${url}`,
        },
      })),
    },
    '@context': 'http://schema.org',
  });
  return (
    <Helmet>
      <script type="application/ld+json">{string}</script>
    </Helmet>
  );
};

BreadcrumbStructuredData.propTypes = {
  canonical: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  })),
  title: PropTypes.string,
};

BreadcrumbStructuredData.defaultProps = {
  canonical: '',
  breadcrumbs: [],
  title: '',
};

export { BreadcrumbStructuredData };
